import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddOwner from "../../../modals/yourAssets/BOA/CustomSubOwnersModal";
import {
  addSubOwnersValidationSchemaDonations as validationSchema,
  donations,
} from "../../../modals/yourAssets/BOA/helper";
import {
  addLoansInitialValues,
  addDonationsInitialValues,
} from "../../../modals/yourAssets/BOA/helper";
import { SecondaryButton } from "../../../common/Buttons";
import DeleteDataModal from "../../../modals/yourAssets/BOA/DeleteDataModal";

import toast, { Toaster } from "react-hot-toast";
import SimpleBarReact from "simplebar-react";
import { Typography } from "@mui/material";
import ImportData from "./ImportData";
import {
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  getUserIdFromLocalStorage,
  changeUpdateFormat,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { assetStepsNames } from "../../../constants/constants";
import ModifiedByToaster from "../../../common/ModifiedByToaster";
import { updateAuditTrails } from "../../../services/auditTrails";
import {
  getAllDonations,
  updateDonations,
} from "../../../services/yourAssets/DonationsServices";
import { useDispatch, useSelector } from "react-redux";
import FilePreviewModal from "../BOA/FilePreviewModal";
import DeleteFileModal from "../../../modals/yourAssets/BOA/DeleteFileModal";
import { getFile } from "../../../services/yourAssets/BankBalancesServices";
import { deleteUserMediaBOA } from "../../../services/yourAssets/CommonServices";
import { handleReloadFiles } from "../../../redux/slices/yourAssets/AssetsDocumentsSlice";

const Summary = (props) => {
  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const { t, i18n } = useTranslation();
  const { next } = props;
  const [summaryValues, handleSetSummaryValues] = useState([]);
  const [checkChanges, setCheckChanges] = useState(false);
  const [apiResponse, setApiResponse] = useState([]);
  const [deleteDataModal, setDeleteDataModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [initialValues, setInitialValues] = useState(null);
  const [showSubOwnersModal, setShowSubOwnersModal] = useState(false);
  const [userName, setUserName] = useState("");
  const [deleteModalData, setDeleteModalData] = useState({
    object: {},
    mainUser: "",
    subUser: "",
    id: 0,
    index: 0,
  });
  const [continueButton, setContinueButton] = useState(true);
  const [updatedIds, setUpdatedIds] = useState([]);
  const [updatesList, setUpdatesList] = useState([]);
  const [btnDisable, setBtnDisable] = useState(false);
  const [focusedDocument, setFocusedDocument] = useState({});
  const [isDeletingFile, setIsDeletingFile] = useState(false);
  const [fileStream, setFileStream] = useState("");
  const [fileName, setFileName] = useState("");
  const [previewDocument, setPreviewDocument] = useState(false);
  const [deleteDocumentModal, setDeleteDocumentModal] = useState(false);
  const documentList = useSelector(
    (state) => state.assetsDocuments.documents.donations
  );
  const dispatch = useDispatch();

  const getListing = async () => {
    setBtnDisable(true);
    let result = await getAllDonations(uID);
    if (result?.success) {
      setApiResponse(result?.payLoad);
      let list = result?.payLoad;
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const elementI = list[i];
        let mainObj = {
          donatedThings: elementI?.donatedThings,
          donationValue: elementI?.donationValue,
          id: elementI?.donationId,

          owner: {
            donatedThings: elementI?.donatedThings,
            donationValue: elementI?.donationValue,
            donationFrom: elementI?.donationFrom,
            dateOfValue: elementI?.dateOfValue?.substring(0, 10),

            id: elementI?.donationId,
            subOwners: [],
          },
        };

        for (let j = 0; j < elementI.subDonations.length; j++) {
          const elementJ = elementI.subDonations[j];
          elementJ.id = elementJ.subDonationId;
          elementJ.loanId = elementI.donationId;

          delete elementJ.subDonationId;
        }

        mainObj.owner.subOwners = elementI.subDonations;
        array.push(mainObj);
        setContinueButton(false);
      }
      handleSetSummaryValues(array);
    }
    setBtnDisable(false);
  };
  const handleUpdates = async (data) => {
    const result = await updateAuditTrails(data, currentConsultantId);
  };

  useEffect(() => {
    setUpdatedIds(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[9] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[9]?.toLowerCase()
        )
        .map((item) => item?.keyValues?.ObjectId)
    );
    handleUpdates(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[9] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[9]?.toLowerCase()
        )
        .map((item) => item?.auditTrailId)
    );
    setUpdatesList(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[9] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[9]?.toLowerCase()
        )
        .map((item) => item)
    );
  }, [props.updates]);
  useEffect(() => {
    setCheckChanges(false);
    getListing();
  }, [checkChanges]);
  const handleAddOwner = async (values) => {
    if (selectedRow?.type === "owner") {
      if (selectedRow.behaviour === "create") {
        const { donationValue, fixedInterestRate } = values;
        delete values.donationValue;
        handleSetSummaryValues([
          ...summaryValues,
          {
            donationValue: donationValue,
            id: summaryValues.length + 1,
            donatedThings: values.donatedThings,
            owner: {
              ...values,
              donationValue,
              dateOfValue: fixedInterestRate,
              id: summaryValues.length + 1,
              subOwners: [],
            },
          },
        ]);
      } else {
        const { donationValue } = values;
        delete values.donationValue;
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id) {
              return {
                ...item,
                donationValue: donationValue,
                donatedThings: values.donatedThings,
                owner: {
                  ...item.owner,
                  donationValue,
                  ...values,
                  id: item.id,
                },
              };
            }
            return { ...item };
          })
        );
      }
    } else {
      if (selectedRow.behaviour === "create") {
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item.owner?.subOwners
                    ? [
                        ...item.owner.subOwners,
                        {
                          ...values,
                          id:
                            item.owner?.subOwners?.length === 0
                              ? 1
                              : item.owner?.subOwners?.length + 1,
                        },
                      ]
                    : [
                        {
                          ...values,
                          id:
                            item.owner?.subOwners?.length === 0
                              ? 1
                              : item.owner?.subOwners?.length + 1,
                        },
                      ],
                },
              };
            return { ...item };
          }) || []
        );
      } else {
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item?.owner?.subOwners?.map((subowner, index) => {
                    if (initialValues.id === subowner.id) {
                      return {
                        ...values,
                        id: subowner?.id,
                        donationId: subowner?.donationId,
                      };
                    }
                    return subowner;
                  }),
                },
              };
            return { ...item };
          }) || []
        );
      }
    }
    setContinueButton(false);
  };
  const handleMainSubmit = async () => {
    setBtnDisable(true);
    let array = [];
    for (let i = 0; i < summaryValues.length; i++) {
      const elementI = summaryValues[i];
      let mainObj = {
        donationId: elementI.id?.length > 10 ? elementI.id : "",
        donationValue: elementI.donationValue,
        donatedThings: elementI.owner.donatedThings,
        donationFrom: elementI.owner.donationFrom,
        dateOfValue: elementI.owner.dateOfValue,

        subDonations: [],
      };
      for (let index = 0; index < elementI.owner.subOwners?.length; index++) {
        const elementJ = elementI.owner.subOwners[index];
        elementJ["subDonationId"] = elementJ.id?.length > 10 ? elementJ.id : "";

        elementJ["donationId"] =
          elementJ?.donationId?.length > 10 ? elementJ?.donationId : "";
        delete elementJ.id;
      }
      mainObj.subDonations = elementI.owner.subOwners;
      array.push(mainObj);
    }
    let result = await updateDonations(array, uID);
    if (result?.success) {
      setCheckChanges(true);
      setBtnDisable(false);
      // toast.success(t(getKeyFromText(result?.message)));
    } else {
      setBtnDisable(false);
      toast.error(result?.message);
    }
  };

  const handleSubOwnersModalOpen = () => {
    setShowSubOwnersModal(true);
  };

  const handleSubOwnersModalClose = () => {
    setSelectedRow(null);
    setShowSubOwnersModal(false);
  };
  const handleSetSelectedRow = (item, type, behaviour = "create") => {
    setSelectedRow({ ...item, type, behaviour });
  };
  const getInitialValues = () => {
    if (initialValues !== null) {
      return {
        donatedThings: initialValues?.donatedThings
          ? initialValues.donatedThings
          : "",
        donationValue: initialValues?.donationValue
          ? initialValues?.donationValue
          : "",
        donationFrom: initialValues?.donationFrom
          ? initialValues?.donationFrom
          : "",
        dateOfValue: initialValues?.dateOfValue
          ? initialValues?.dateOfValue
          : "",
      };
    }
    return addDonationsInitialValues;
  };

  const handleDeleteOwner = (type, id, index) => {
    if (type === "owner") {
      handleSetSummaryValues(
        summaryValues.filter((item, itemIndex) => itemIndex !== index)
      );
      summaryValues.map((item, itemIndex) => {
        if (itemIndex === index)
          return {
            nameOfOwner: item.companyName,
            id: item.id,
          };
        return item;
      });
    } else {
      handleSetSummaryValues(
        summaryValues.map((item, itemIndex) => {
          if (itemIndex === index)
            return {
              ...item,
              owner: {
                ...item.owner,
                subOwners: item.owner.subOwners.filter(
                  (subOwner) => subOwner.id !== id
                ),
              },
            };
          return item;
        })
      );
    }
  };

  const handleDeleteDataModal = (object, mainUser, subUser, id, index) => {
    let obj = {
      object,
      mainUser,
      subUser,
      id,
      index,
    };
    setDeleteModalData(obj);
    setDeleteDataModal(true);
  };
  const handleDeleteData = () => {
    handleSetSelectedRow(deleteModalData.object, deleteModalData.mainUser);
    handleDeleteOwner(
      deleteModalData.subUser,
      deleteModalData.id,
      deleteModalData.index
    );
  };
  const totalValue = () => {
    let count = 0;
    summaryValues.forEach((el) => {
      if (el.owner.donationValue) {
        count += +el.owner.donationValue;
      }
    });
    return count.toLocaleString("de-DE");
  };

  const donnationValueFormatter = (value) => {
    return value.toLocaleString("de-DE");
  };

  const handleRemoveFile = (obj) => {
    setFocusedDocument(obj);
    setDeleteDocumentModal(true);
  };
  const handleClosePreviewModal = () => {
    setPreviewDocument(false);
    setFocusedDocument("");
    setFileStream("");
  };
  const handleCloseDeleteModal = () => {
    setDeleteDocumentModal(false);
  };
  const handleViewFile = async (document) => {
    const { boaUserMediaFileId, originalFilename } = document;
    setFileName(originalFilename);
    const result = await getFile({
      userId: uID,
      boaMediaId: boaUserMediaFileId,
    });
    if (result?.payLoad) {
      setFileStream(result.payLoad);
      setPreviewDocument(true);
      setFocusedDocument(document);
    }
  };
  const handleDeleteFile = async () => {
    setIsDeletingFile(true);
    const { boaUserMediaFileId } = focusedDocument;
    const result = await deleteUserMediaBOA(uID, boaUserMediaFileId);
    if (result?.success) {
      // toast.success(t(getKeyFromText(result?.message)));
      handleCloseDeleteModal();
      handleClosePreviewModal();
      dispatch(handleReloadFiles());
      setIsDeletingFile(false);
    }
  };
  const handleDeleteModalShow = () => setDeleteDocumentModal(true);

  return (
    <React.Fragment>
      <Toaster />
      {showSubOwnersModal && (
        <AddOwner
          open={showSubOwnersModal}
          handleOpen={handleSubOwnersModalOpen}
          handleClose={handleSubOwnersModalClose}
          handleDelete={() => {}}
          handleSubmit={handleAddOwner}
          type={selectedRow && selectedRow.type}
          id={selectedRow && selectedRow.id}
          selectedRow={selectedRow ? selectedRow : null}
          getInitialValues={getInitialValues}
          enteries={donations(t)}
          validationSchema={validationSchema(t)}
          user={userName}
          companyName={selectedRow.companyName}
          tabName={t("donations")}
        />
      )}
      <DeleteDataModal
        open={deleteDataModal}
        handleClose={() => {
          setDeleteDataModal(false);
        }}
        handleDelete={handleDeleteData}
        newFlow={true}
        user={deleteModalData?.object?.donatedThings}
      />
      <Box className="shareholdings-container">
        <Box className="table-n-btns-wrapper">
          <Box
            className="upload-add-btn-wrapper"
            component="div"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <SecondaryButton
              title={
                <>
                  <Typography
                    sx={{
                      fontWeight: 900,
                      fontSize: "1.5rem",
                      position: "absolute",
                      left: "7%",
                    }}
                  >
                    +
                  </Typography>{" "}
                  {t("add-line")}
                </>
              }
              border="none"
              textTransform="initial"
              fontWeight="normal"
              bgColor="color.magentaLight2"
              borderRadius="40px"
              padding="2px auto"
              minWidth="235px"
              marginLeft="20px"
              hoverBgColor="color.magentaLight1"
              click={() => {
                setInitialValues(null);
                setShowSubOwnersModal(true);
                setSelectedRow({ type: "owner", behaviour: "create" });
                setUserName("Shareholding");
              }}
            />
            <ImportData
              sectionId={11}
              documentList={documentList}
              handleRemoveFile={handleRemoveFile}
              handleViewFile={handleViewFile}
            />
          </Box>
          {/* <SimpleBarReact style={{ maxHeight: 300 }} autoHide={false}> */}
          <TableContainer component={Paper} className="summary-table">
            <Table
              sx={{
                "th , td": { border: "none" },
              }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead stickyHeader>
                <TableRow>
                  <TableCell align="left">
                    {t("donation-table-heading-1")}
                  </TableCell>
                  <TableCell align="left">
                    {t("donation-table-heading-2")}
                  </TableCell>
                  <TableCell align="left">
                    {t("donation-table-heading-4")}
                  </TableCell>
                  <TableCell align="left">
                    {t("donation-table-heading-3")}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {summaryValues.map((item, index) => (
                  <>
                    <TableRow
                      sx={{
                        backgroundColor: `${
                          index % 2 === 0 ? "color.smokeWhite" : "color.white"
                        }`,
                      }}
                      className={
                        updatedIds.includes(item.id)
                          ? "highlighted-table-row"
                          : ""
                      }
                    >
                      <TableCell>
                        {item?.owner?.dateOfValue
                          ? item.owner.dateOfValue
                              .slice(0, 10)
                              .split("-")
                              .reverse()
                              .join("-")
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {item?.donatedThings ? item.donatedThings : "-"}
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          {item?.owner?.donationFrom ? (
                            <>
                              {item.owner.donationFrom}{" "}
                              {
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  aria-label="Add"
                                  size="small"
                                  onClick={() => {
                                    setInitialValues({
                                      ...addDonationsInitialValues,
                                      // donationValue: item.donationValue,
                                    });
                                    setUserName(item.owner.nameOfOwner);
                                    handleSubOwnersModalOpen();
                                    handleSetSelectedRow(item, "subOwner");
                                  }}
                                >
                                  <AddCircleOutlineSharpIcon />
                                </IconButton>
                              }
                            </>
                          ) : (
                            "-"
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {item?.owner?.donationValue
                          ? `${donnationValueFormatter(
                              item.owner.donationValue
                            )} €`
                          : "-"}
                      </TableCell>
                      <TableCell>
                        <>
                          <IconButton
                            sx={{ cursor: "pointer" }}
                            aria-label="add"
                            size="small"
                            onClick={() => {
                              handleSetSelectedRow(item, "owner", "edit");
                              setInitialValues({
                                donationValue: item.donationValue,
                                ...item.owner,
                              });
                              setUserName(item.owner.donationValue);
                              handleSubOwnersModalOpen();
                            }}
                          >
                            <img src="/assets/icons/edit-icon.svg" alt="edit" />
                          </IconButton>
                          <IconButton
                            sx={{ cursor: "pointer" }}
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                              handleDeleteDataModal(
                                item,
                                "owner",
                                "owner",
                                item.id,
                                index
                              );
                              setUserName(item.donationValue);
                            }}
                          >
                            <img
                              src="/assets/icons/delete-icon.svg"
                              alt="delete"
                            />
                          </IconButton>
                        </>
                      </TableCell>
                    </TableRow>
                    {item?.owner?.subOwners?.length > 0 &&
                      item.owner.subOwners.map((owner, ownerIndex) => {
                        return (
                          <TableRow
                            key={ownerIndex}
                            sx={{
                              backgroundColor: `${
                                index % 2 === 0
                                  ? "color.smokeWhite"
                                  : "color.white"
                              }`,
                            }}
                            className={
                              updatedIds.includes(owner?.id)
                                ? "highlighted-table-row"
                                : ""
                            }
                          >
                            <TableCell></TableCell>
                            <TableCell>
                              {owner.donatedThings ? owner.donatedThings : "-"}
                            </TableCell>
                            <TableCell>
                              {owner.donationFrom ? owner.donationFrom : "-"}
                            </TableCell>
                            <TableCell>
                              {owner?.donationValue
                                ? `${donnationValueFormatter(
                                    owner.donationValue
                                  )} €`
                                : "-"}
                            </TableCell>

                            <TableCell>
                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="add"
                                size="small"
                                onClick={() => {
                                  handleSetSelectedRow(
                                    item,
                                    "subOwner",
                                    "edit"
                                  );
                                  setInitialValues({
                                    donationValue: item.donationValue,
                                    ...owner,
                                  });
                                  setUserName(owner.donationValue);
                                  handleSubOwnersModalOpen();
                                }}
                              >
                                <img
                                  src="/assets/icons/edit-icon.svg"
                                  alt="edit"
                                />
                              </IconButton>
                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="delete"
                                size="small"
                                onClick={() => {
                                  handleDeleteDataModal(
                                    item,
                                    "owner",
                                    "subOwner",
                                    owner.id,
                                    index
                                  );
                                  setUserName(item.donationValue);
                                }}
                              >
                                <img
                                  src="/assets/icons/delete-icon.svg"
                                  alt="delete"
                                />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </>
                ))}
                <TableRow sx={{ background: "#dfc8db" }}>
                  {/* <TableCell></TableCell> */}
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right">{t("total")}</TableCell>
                  <TableCell
                    sx={{ paddingLeft: "16px !important" }}
                    align="left"
                  >
                    {/* &nbsp;  */}
                    {`${totalValue()} € `}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          {/* </SimpleBarReact> */}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SecondaryButton
            title={t("save-and-continue")}
            bgColor="color.magentaLight2"
            borderRadius="14px"
            width="200px"
            marginLeft="20px"
            border="none"
            hoverBgColor="color.magentaLight1"
            click={handleMainSubmit}
            textTransform="initial"
            disabled={btnDisable}
          />
        </Box>
      </Box>
      {updatesList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${updatesList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            updatesList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}
      {previewDocument && (
        <FilePreviewModal
          data={fileStream}
          handleClose={handleClosePreviewModal}
          handleDelete={handleDeleteModalShow}
          fileName={fileName}
        />
      )}
      {deleteDocumentModal && (
        <DeleteFileModal
          show={deleteDocumentModal}
          document={focusedDocument}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDeleteFile}
        />
      )}
    </React.Fragment>
  );
};

export default Summary;
